<div class="d-flex flex-column flex-shrink-0 p-3 bg-light bff-sidebar" style="width: 280px;">
  <button type="button" class="bff-sidebar__close bff-hide-desktop" (click)="closeSidebar()">
    <i class="fa fa-times"></i>
  </button>
  <div class="bff-sidebar-content">
    <ul class="nav nav-pills flex-column mb-auto" *ngIf="!isAdmin()">
      <!-- Ajouter une opération -->
      <li class="nav-item bff-sidebar-add-op">
        <a routerLink="/front/operation" [queryParams]="{addOp: 'true'}" class="nav-link bff-sidebar-add-op__link" (click)="closeSidebar()">
          <span class="bff-sidebar-add-op__btn">
            <i class="fa-solid fa-plus"></i>
          </span>
          <span class="bff-sidebar-add-op__label-long">Ajouter une opération</span>
          <span class="bff-sidebar-add-op__label-short">Opé</span>
        </a>
      </li>

      <!-- Home -->
      <li class="nav-item">
        <a routerLink="/front/dashboard" class="nav-link"  routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-house fa-lg me-2"></i>
          <span>{{ 'leftmenu.home' | translate }}</span>
        </a>
      </li>

    <!-- Bank Accounts -->
    <li class="nav-item">
      <div class="nav-link d-flex align-items-center justify-content-between"
         [class.active]="isSubMenuOpen('operation')"
           [class.submenu-active]="isSubMenuActive('operation')">
        <a [routerLink]="'/front/operation'"
           (click)="onMainMenuClick($event, 'operation', '/front/operation')"
           class="d-flex align-items-center flex-grow-1">
          <i class="fa-solid fa-wallet fa-lg me-2"></i>
          <span>{{ 'leftmenu.my-bank-accounts' | translate }}</span>
        </a>
        <i class="fa-solid"
           (click)="toggleSubMenu('operation')"
           [ngClass]="{
             'fa-chevron-down': isSubMenuOpen('operation'),
             'fa-chevron-right': !isSubMenuOpen('operation')
           }"
           style="cursor:pointer"></i>
      </div>
      <div class="collapse" [class.show]="isSubMenuOpen('operation')">
        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small hierarchy-menu">
          <li>
            <a routerLink="/front/operation" class="nav-link rounded" routerLinkActive="nav-link-active"
               [routerLinkActiveOptions]="{ exact: true }"
               (click)="closeSidebar()">
               {{ 'leftmenu.operations' | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/front/operation/search" class="nav-link rounded" routerLinkActive="nav-link-active"
               [routerLinkActiveOptions]="{ exact: true }"
               (click)="closeSidebar()">
               {{ 'leftmenu.operations.search' | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/front/operation/average-budget" class="nav-link rounded" routerLinkActive="nav-link-active"
               [routerLinkActiveOptions]="{ exact: true }"
               (click)="closeSidebar()">
               {{ 'leftmenu.analysis.incomeExpense' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </li>

    <!-- Budget -->
    <li class="nav-item">
      <div class="nav-link d-flex align-items-center justify-content-between"
         [class.active]="isSubMenuOpen('previsionnel')"
         [class.submenu-active]="isSubMenuActive('previsionnel')">
        <a [routerLink]="'/front/previsionnel/budget/details'"
           (click)="onMainMenuClick($event, 'previsionnel', '/front/previsionnel/budget/details')"
           class="d-flex align-items-center flex-grow-1">
          <i class="fa-solid fa-chart-bar fa-lg me-2"></i>
          <span>{{ 'leftmenu.my-budget' | translate }}</span>
        </a>
        <i class="fa-solid"
           (click)="toggleSubMenu('previsionnel')"
           [ngClass]="{
             'fa-chevron-down': isSubMenuOpen('previsionnel'),
             'fa-chevron-right': !isSubMenuOpen('previsionnel')
           }"
           style="cursor:pointer"></i>
      </div>
      <div class="collapse" [class.show]="isSubMenuOpen('previsionnel')">
        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small hierarchy-menu">
          <li>
            <a routerLink="/front/previsionnel/budget/details" class="nav-link rounded" routerLinkActive="nav-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="closeSidebar()">
              {{ 'leftmenu.previsionnel.budget.favorite' | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/front/previsionnel/difftable" class="nav-link rounded" routerLinkActive="nav-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="closeSidebar()">
              {{ 'leftmenu.previsionnel.table' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </li>

    <!-- Patrimony -->
    <li class="nav-item">
      <div class="nav-link d-flex align-items-center justify-content-between"
         [class.active]="isSubMenuOpen('patrimony')"
         [class.submenu-active]="isSubMenuActive('patrimony')">
        <a [routerLink]="'/front/indicator/pat'"
           (click)="onMainMenuClick($event, 'patrimony', '/front/indicator/pat')"
           class="d-flex align-items-center flex-grow-1">
          <i class="fa-solid fa-piggy-bank fa-lg me-2"></i>
          <span>{{ 'leftmenu.my-patrimony' | translate }}</span>
        </a>
        <i class="fa-solid"
           (click)="toggleSubMenu('patrimony')"
           [ngClass]="{
             'fa-chevron-down': isSubMenuOpen('patrimony'),
             'fa-chevron-right': !isSubMenuOpen('patrimony')
           }"
           style="cursor:pointer"></i>
      </div>
      <div class="collapse" [class.show]="isSubMenuOpen('patrimony')">
        <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small hierarchy-menu">
          <li>
            <a routerLink="/front/indicator/pat" class="nav-link rounded" routerLinkActive="nav-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="closeSidebar()">
              {{ 'leftmenu.analysis.patrimony' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </li>

    <!-- Diagnostic IA (DEV only) -->
    <li class="nav-item" *ngIf="isDevUser()">
      <a routerLink="/front/diagnostic" class="nav-link" routerLinkActive="nav-link-active"
         [routerLinkActiveOptions]="{ exact: true }"
         (click)="closeSidebar()">
        <i class="fa-solid fa-wand-magic-sparkles fa-lg me-2"></i>
        <span>{{ 'leftmenu.diagnostic' | translate }}</span>
      </a>
    </li>

    <!-- Indicators -->
    <li class="nav-item">
      <div class="nav-link d-flex align-items-center justify-content-between"
         [class.active]="isSubMenuOpen('indicator')"
         [class.submenu-active]="isSubMenuActive('indicator')">
        <a [routerLink]="'/front/indicator/analysis'"
           (click)="onMainMenuClick($event, 'indicator', '/front/indicator/analysis')"
           class="d-flex align-items-center flex-grow-1">
          <i class="fa-solid fa-chart-line fa-lg me-2"></i>
          <span>{{ 'leftmenu.analysis' | translate }}</span>
        </a>
        <i class="fa-solid"
           (click)="toggleSubMenu('indicator')"
           [ngClass]="{
             'fa-chevron-down': isSubMenuOpen('indicator'),
             'fa-chevron-right': !isSubMenuOpen('indicator')
           }"
           style="cursor:pointer"></i>
      </div>
      <div class="collapse" [class.show]="isSubMenuOpen('indicator')">
        <div class="submenu-tree">
          <ul class="btn-toggle-nav list-unstyled fw-normal pb-1 small hierarchy-menu">
          <li>
            <a routerLink="/front/indicator/analysis" class="nav-link rounded" routerLinkActive="nav-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="closeSidebar()">
              {{ 'leftmenu.analysis.category' | translate }}
            </a>
          </li>
          <li>
            <a routerLink="/front/previsionnel/statement" class="nav-link rounded" routerLinkActive="nav-link-active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeSidebar()">
              {{ 'leftmenu.previsionnel.statement' | translate }}
            </a>
          </li>
        </ul>
        </div>
      </div>
    </li>

      <!-- Comparator -->
      <!-- <li class="nav-item">
        <a routerLink="/front/comparator" class="nav-link" routerLinkActive="active">
          <i class="fa-solid fa-chart-line fa-lg me-2"></i>
          <span>{{ 'leftmenu.comparator' | translate }}</span>
        </a>
      </li> -->

      <!-- Parameters -->
      <li class="nav-item">
        <a routerLink="/front/parameters" class="nav-link" routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-screwdriver-wrench fa-lg me-2"></i>
          <span>{{ 'leftmenu.parameters' | translate }}</span>
        </a>
      </li>

      <!-- Help -->
      <li class="nav-item">
        <a routerLink="/front/help" class="nav-link" routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-circle-info fa-lg me-2"></i>
          <span>{{ 'leftmenu.help' | translate }}</span>
        </a>
      </li>
    </ul>
    <ul class="nav nav-pills flex-column mb-auto" *ngIf="isAdmin()">
      <!-- Home -->
      <li class="nav-item">
        <a routerLink="/admin/admin-index" class="nav-link"  routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-house fa-lg me-2"></i>
          <span>{{ 'leftmenu.home' | translate }}</span>
        </a>
      </li>

      <li class="nav-item">
        <a routerLink="/admin/users" class="nav-link"  routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-users fa-lg me-2"></i>
          <span>{{ 'admin.users.menu' | translate }}</span>
        </a>
      </li>
    <li class="nav-item">
      <a routerLink="/admin/bons-plans" class="nav-link"  routerLinkActive="nav-link-active"
    [routerLinkActiveOptions]="{ exact: true }"
    (click)="closeSidebar()">
        <i class="fas fa-percent fa-lg me-2"></i>
        <span>{{ 'admin.bons-plans.menu' | translate }}</span>
      </a>
    </li>
      <li class="nav-item">
        <a routerLink="/admin/versions" class="nav-link"  routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-code-branch fa-lg me-2"></i>
          <span>{{ 'admin.versions.menu' | translate }}</span>
        </a>
      </li>
      <li class="nav-item">
        <a routerLink="/admin/cgu" class="nav-link"  routerLinkActive="nav-link-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeSidebar()">
          <i class="fa-solid fa-file-contract fa-lg me-2"></i>
          <span>{{ 'admin.cgu.menu' | translate }}</span>
        </a>
      </li>
      
      
    </ul>
  </div>
  <div class="bff-sidebar-footer">
    <span class="bff-sidebar-version">{{ 'topmenu.version' | translate }} {{ appVersion }}</span>
  </div>
</div>
